/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/styles';

import Footer from './footer';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { BREAKPOINTS } from '../styles/constants';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  toolbar: {
    marginTop: BREAKPOINTS.topbar,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    marginTop: 30,
    backgroundColor: '#fff',
    marginBottom: 20,
    padding: 20,
    [BREAKPOINTS.md]: {
      padding: 50,
      maxWidth: 800,
    },
  },
  mainWrap: {
    marginLeft: 0,
    marginTop: BREAKPOINTS.topbar,
    [BREAKPOINTS.md]: {
      marginTop: BREAKPOINTS.topbar,
      marginLeft: drawerWidth,
    },
  },
}));

const DocsLayout = ({ children, hasSidebar }) => {
  const classes = useStyles();
  const [open, setOpen] = useState();
  const drawerToggle = useCallback(
    e => {
      setOpen(!open);
    },
    [open],
  );

  return (
    <StaticQuery
      query={graphql`
        query SiteDocsQuery {
          site {
            siteMetadata {
              title
              company
            }
          }
        }
      `}
      render={data => (
        <div className={classes.root}>
          <Navbar
            hasSidebar={hasSidebar}
            drawerToggle={drawerToggle}
            open={open}
          />

          {hasSidebar && <Sidebar drawerToggle={drawerToggle} open={open} />}
          <div className={classes.toolbarMixin} />
          <div className={classes.mainWrap}>
            <Container component="main" className={classes.main} maxWidth="sm">
              {children}
            </Container>
          </div>
          <Footer siteTitle={data.site.siteMetadata.company} />
        </div>
      )}
    />
  );
};

DocsLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DocsLayout;
